"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChildItems = void 0;
const react_1 = __importStar(require("react"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const item_1 = require("./item");
const styled_components_1 = __importDefault(require("styled-components"));
const Styled = (0, styled_components_1.default)(wl_ui_kit_1.List) `
  padding-top: ${(0, wl_ui_kit_1.getSizeBy)(2)};
  padding-bottom: ${({ $isLatest }) => ($isLatest ? '0px' : (0, wl_ui_kit_1.getSizeBy)(2))};
`;
exports.ChildItems = (0, react_1.memo)(({ isOpen, childItems, parent, toggle, onItemClick, checkSelection, isLatest }) => {
    const hasChildren = (0, react_1.useMemo)(() => !!childItems, [childItems]);
    return hasChildren ? (react_1.default.createElement(wl_ui_kit_1.Collapse, { isOpen: isOpen, component: "li" },
        react_1.default.createElement(Styled, { "$isLatest": isLatest }, childItems === null || childItems === void 0 ? void 0 : childItems.map((childItem, index) => (react_1.default.createElement(item_1.Item, { key: childItem.id, item: childItem, parent: parent, toggle: toggle, onItemClick: onItemClick, checkSelection: checkSelection, isLatest: index === childItems.length - 1 })))))) : null;
});
